import { IAppState } from '../../redux';
import { getDealAndObjectType } from '../../utils/analytics';
import { selectOfferCategory } from '../offer';

export const selectAnalyticsDealObjectString = (state: IAppState): string => {
  const category = selectOfferCategory(state);

  const { dealType, objectType } = getDealAndObjectType(category);

  return [dealType, objectType].filter(Boolean).join('/');
};
